import { FhsAxios } from "../../services/axios";
import { hasItBeenLoaded } from "@/helpers/loading";

export default {
  state: {
    instructionsList: null
  },
  actions: {
    fetchInstructions({ commit, getters, state }, dateRange = {}) {
      commit("unsetInstructionsList");
      // Если данные уже загружены, то выходим из функции
      if (hasItBeenLoaded(state.instructionsList)) {
        return;
      }
      // Создаем базовый url для запроса
      let url = "orders";
      // Если пользователь - VIP и пользователь выбрал определенного брокера, добавляем в запрос ID брокера (получаем данные только по выбранному брокеру)
      if (
        getters.selectedPortfolio !== "all" &&
        getters.selectedPortfolio !== undefined
      ) {
        url += "/" + getters.selectedPortfolio;
      }

      FhsAxios.post(url, {
        ...dateRange
      }).then(response => {
        let instructionsList = response.data.result.data;
        commit("setInstructionsList", instructionsList);
      });
    },
    clearInstructions({ commit }) {
      commit("unsetInstructionsList");
    }
  },
  mutations: {
    setInstructionsList(state, instructionsList) {
      state.instructionsList = instructionsList;
    },
    unsetInstructionsList(state) {
      state.instructionsList = null;
    }
  },
  getters: {
    instructionsList(state) {
      return state.instructionsList || [];
    },
    isInstructionsListLoading(state) {
      return state.instructionsList === null;
    }
  }
};
